// @flow

import { gql } from "@apollo/client";

export default {
  proof: gql`
    fragment DesignProofListItem_proof on Proof {
      asset {
        url {
          formatted
        }
      }
      originalFilename
    }
  `
};
